import React from 'react';
import { 
    DndContext,
    pointerWithin,
    DragOverlay,
} from '@dnd-kit/core';
import {
    SortableContext,
    verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import DroppableCategory from './DroppableCategory';
import SortableCategory from './SortableCategory';
import SortableGroceryV2Item from './SortableGroceryV2Item';
import CategoryContent from './CategoryContent';
import GroceryV2Item from './GroceryV2Item';

const GroceryV2List = ({
    sensors,
    items,
    categories,
    selectedItems,
    overId,
    activeId,
    handleDragStart,
    handleDragOver,
    handleDragEnd,
    handleDragCancel,
    handleRemoveItem,
    handleEditItem,
    handleCheckItem,
    handleItemSelect,
    handleRemoveCategory,
    editMode
}) => {
    return (
        <div className={'flex flex-col w-full md:w-2/3 h-full mx-auto'}>
            <DndContext
                sensors={sensors}
                collisionDetection={pointerWithin}
                onDragStart={handleDragStart}
                onDragOver={handleDragOver}
                onDragEnd={handleDragEnd}
                onDragCancel={handleDragCancel}
            >
                <div>
                    <DroppableCategory id="uncategorized" name="Uncategorized Items">
                        <SortableContext items={items.filter(item => !item.category).map(item => item.id)} strategy={verticalListSortingStrategy}>
                            {items.filter(item => !item.category).map((item, index, array) => (
                                <SortableGroceryV2Item
                                    key={item.id}
                                    id={item.id}
                                    text={item.text}
                                    onRemove={() => handleRemoveItem(item.id)}
                                    onEdit={(newText) => handleEditItem(item.id, newText)}
                                    onCheck={() => handleCheckItem(item.id)}
                                    isChecked={item.isChecked}
                                    isOver={overId?.id === item.id ? overId.position : false}
                                    isSelected={selectedItems.includes(item.id)}
                                    onSelect={() => handleItemSelect(item.id)}
                                    isLast={index === array.length - 1}
                                    editMode={editMode}
                                />
                            ))}
                        </SortableContext>
                    </DroppableCategory>
                    <SortableContext items={categories.map(cat => cat.id)} strategy={verticalListSortingStrategy}>
                        {categories.map((category) => (
                            <SortableCategory
                                key={category.id}
                                id={category.id}
                                name={category.name}
                                onRemove={() => handleRemoveCategory(category.id)}
                                isOver={overId?.id === category.id}
                                editMode={editMode}
                            >
                                <SortableContext items={items.filter(item => item.category === category.id).map(item => item.id)} strategy={verticalListSortingStrategy}>
                                    {items.filter(item => item.category === category.id).map((item, index, array) => (
                                        <SortableGroceryV2Item
                                            key={item.id}
                                            id={item.id}
                                            text={item.text}
                                            onRemove={() => handleRemoveItem(item.id)}
                                            onEdit={(newText) => handleEditItem(item.id, newText)}
                                            onCheck={() => handleCheckItem(item.id)}
                                            isChecked={item.isChecked}
                                            isOver={overId?.id === item.id ? overId.position : false}
                                            isSelected={selectedItems.includes(item.id)}
                                            onSelect={() => handleItemSelect(item.id)}
                                            isLast={index === array.length - 1}
                                            editMode={editMode}
                                        />
                                    ))}
                                </SortableContext>
                            </SortableCategory>
                        ))}
                    </SortableContext>
                </div>
                <DragOverlay 
                    adjustScale={false}
                    dropAnimation={{
                        duration: 200,
                        easing: 'cubic-bezier(0.18, 0.67, 0.6, 1.22)',
                    }}
                    style={{
                        cursor: 'grabbing',
                        transformOrigin: '0 0',
                    }}
                >
                    {activeId ? (
                        activeId.startsWith('cat') || categories.some(cat => cat.id === activeId) ? (
                            <div className="transform rotate-3 opacity-90 shadow-2xl">
                                <CategoryContent
                                    name={categories.find((cat) => cat.id === activeId)?.name || ''}
                                    isDragging
                                />
                            </div>
                        ) : (
                            <div className="relative transform rotate-1 opacity-95 shadow-xl pointer-events-none" style={{ 
                                transformOrigin: '48px 50%',  // Position based on grip icon location
                                marginLeft: '-48px',  // Offset to align with grip icon
                                marginTop: '-12px'    // Small vertical adjustment
                            }}>
                                <GroceryV2Item
                                    id={activeId}
                                    text={items.find((item) => item.id === activeId)?.text || ''}
                                    onRemove={() => {}}
                                    onEdit={() => {}}
                                    onCheck={() => {}}
                                    isChecked={items.find((item) => item.id === activeId)?.isChecked || false}
                                    editMode={editMode}
                                />
                                {selectedItems.length > 1 && (
                                    <div className="absolute top-0 right-0 -mt-2 -mr-2 bg-blue-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs">
                                        +{selectedItems.length - 1}
                                    </div>
                                )}
                            </div>
                        )
                    ) : null}
                </DragOverlay>
            </DndContext>
        </div>
    );
};

export default GroceryV2List;
